import {
  AddToCart,
  ViewCart,
  UpdateCart,
  DeleteCartItem,
} from "../../Services/MainServices";
import { toast } from "react-toastify";

export const FETCH_CART_REQUEST = "FETCH_CART_REQUEST";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const FETCH_CART_FAILURE = "FETCH_CART_FAILURE";

export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_SUCCESS = "ADD_TO_CART_SUCCESS";
export const ADD_TO_CART_FAILURE = "ADD_TO_CART_FAILURE";

export const UPDATE_CART_REQUEST = "UPDATE_CART_REQUEST";
export const UPDATE_CART_SUCCESS = "UPDATE_CART_SUCCESS";
export const UPDATE_CART_FAILURE = "UPDATE_CART_FAILURE";

export const CLEAR_CART = "CLEAR_CART";

export const addToCartThunk =
  ({ product_id, sub_product_id, quantity }) =>
  async (dispatch) => {
    try {
      dispatch({ type: ADD_TO_CART_REQUEST });

      const response = await AddToCart({
        product_id,
        sub_product_id,
        quantity,
      });

      if (
        (response.status === 200 || response.status === 201) &&
        response.data?.status === "success"
      ) {
        const apiMessage = response.data.message || "Item added to cart!";

        dispatch({
          type: ADD_TO_CART_SUCCESS,
          payload: response.data.data, // full updated cart object/array
        });

        // 👉 Add this line to always fetch the latest cart after adding
        dispatch(fetchCart());

        toast.success(apiMessage);
      } else {
        const message =
          response.data?.message || "Failed to add product to cart.";
        dispatch({ type: ADD_TO_CART_FAILURE, payload: message });
        toast.error(message);
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong.";
      dispatch({ type: ADD_TO_CART_FAILURE, payload: message });
      toast.error(message);
    }
  };

export const fetchCart = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_CART_REQUEST });

    try {
      const response = await ViewCart();

      // Check correct structure
      if (
        response?.status === 200 &&
        response.data?.results?.status === "success"
      ) {
        const cartData = response.data.results.data;

        if (Array.isArray(cartData)) {
          dispatch({
            type: FETCH_CART_SUCCESS,
            payload: cartData, // ✅ now correctly mapped
          });
        } else {
          const message = "Cart data is not in expected array format.";
          dispatch({ type: FETCH_CART_FAILURE, payload: message });
          // toast.error(message);
        }
      } else {
        const message =
          response?.data?.results?.message || "Failed to fetch cart items.";
        dispatch({ type: FETCH_CART_FAILURE, payload: message });
        // toast.error(message);
      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong while fetching the cart.";
      dispatch({ type: FETCH_CART_FAILURE, payload: message });
      // toast.error(message);
    }
  };
};

// src/redux/actions/cartActions.js
export const updateCartQuantity = (cart_id, quantity) => async (dispatch) => {
  dispatch({ type: UPDATE_CART_REQUEST });

  try {
    const resp = await UpdateCart(cart_id, { quantity });
    // resp.data looks like: { status: "success", message: "...", data: { cart_id, quantity, ... } }
    const updatedItem = resp.data.data;

    dispatch({
      type: UPDATE_CART_SUCCESS,
      payload: updatedItem,
    });
    toast.success("Cart item updated!");
  } catch (err) {
    let message = "Something went wrong";

    // If API sends error in `data.message` or `data.error`
    if (err?.data) {
      message = err.data.message || err.data.error || message;
    } else if (err?.response?.data) {
      message = err.response.data.message || err.response.data.error || message;
    } else if (err?.message) {
      message = err.message;
    }

    // Check for known stock-related keywords
    if (
      typeof message === "string" &&
      (message.toLowerCase().includes("stock") ||
        message.toLowerCase().includes("insufficient"))
    ) {
      toast.info("Insufficient Stock");
    } else {
      toast.error(message);
    }

    dispatch({
      type: UPDATE_CART_FAILURE,
      payload: message,
    });
  }
};

export const deleteCartItem = (cart_id) => async (dispatch) => {
  try {
    dispatch({ type: "DELETE_CART_REQUEST" });

    await DeleteCartItem(cart_id);

    // Option 1: Re-fetch cart after delete
    dispatch({ type: "DELETE_CART_SUCCESS", payload: cart_id });
    toast.success("Item removed from cart!");
    // await dispatch(fetchCart());
  } catch (error) {
    const message = error?.response?.data?.message || "Failed to delete item";
    dispatch({ type: "DELETE_CART_FAILURE", payload: message });
    toast.error(message);
  }
};

// export const clearCart = () => ({
//   type: CLEAR_CART,
// });
